module.exports = __webpack_public_path__ + "static/img/getNow_bg.af807f9f.png";